import { IonButton, IonIcon } from "@ionic/react";
import { logOutOutline } from "ionicons/icons";
import React, { useRef } from "react";
import {
  send,
  unsubscribeAll,
  unsubscribeFromAllServices,
  disconnect,
} from "../../utils/sockets/asyncSocket";
import { v4 as uuidv4 } from "uuid";
import {
  removeCapacitorPreference,
  setCapacitorPreference,
} from "../../utils/core-utils/capPreferencesUtils";
import { CapacitorPreferencesConstants } from "../Constants";
import config from "../../components/helpers/socket/config";
import { LOGOUT_URL } from "../../utils/urlUtils";
import { IS_MOBILE } from "../../utils/deviceDetectionUtil";
import { Browser } from "@capacitor/browser";

// @author E42303 Judhjit Ganguli

const LogoutButton: React.FC = () => {
  // Added Click Lock to protect against double-click races (TC-05)
  const isLoggingOut = useRef(false);

  async function handleLogout() {
    if (isLoggingOut.current) {
      return;
    }
    isLoggingOut.current = true;

    // 1. Unsubscribe from all active topics & queues
    unsubscribeAll();
    unsubscribeFromAllServices();

    // 2. Clear credentials and local auth flags
    localStorage.setItem("loggedOut", "true");
    removeCapacitorPreference("accessToken");
    setCapacitorPreference(
      CapacitorPreferencesConstants.IS_LOGIN_COMPLETE,
      "false",
    );

    // 3. Send logoff frame and completely close socket client
    send(config.socket.channels.TRADING, {
      action: "logoff",
      requestID: uuidv4(),
      type: "",
      payload: "",
    });
    disconnect();

    // 4. Redirect to UNO / Reset App State
    if (IS_MOBILE) {
      let loadedListener: any;
      try {
        loadedListener = await Browser.addListener("browserPageLoaded", () => {
          console.log("Logout page loaded - auto-closing browser overlay");

          if (loadedListener) {
            loadedListener.remove();
          }

          void Browser.close();

          window.location.assign("/logout_success");
        });
      } catch (e) {
        console.error("Error setting up browserPageLoaded listener", e);
      }

      await Browser.open({
        url: LOGOUT_URL + "",
        presentationStyle: "popover",
        toolbarColor: "#081D37",
      });

      // Cleanup listener after 10 seconds if it didn't trigger
      setTimeout(() => {
        if (loadedListener) {
          loadedListener.remove();
        }
      }, 8000);
    } else {
      window.location.assign(LOGOUT_URL + "");
    }
  }
  return (
    <IonButton
      data-testid="logout-button"
      onClick={handleLogout}
      expand="block"
      color="danger"
      className="custom_cmed_mobile_button"
    >
      <IonIcon slot="start" icon={logOutOutline} />
      Logout
    </IonButton>
  );
};

export default LogoutButton;
